export default "__VITE_ASSET__qKn6fvHW__"